import React, { useState, useRef, useEffect } from 'react';
import "../Styles/RegisterCustomerCode.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { toast, ToastContainer, toast as toastHelper } from 'react-toastify';
import Img from "../Assets/icons/VELOXLogo.png";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const RegisterCustomerCode = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleCreateCustomer = async (values, { resetForm, setSubmitting }) => {
        const email = localStorage.getItem('userEmail');
        const id = (values.id || '').trim();
        const yubikeyserialnumber = (values.yubikeyserialnumber || '').trim();

        try {
            setSubmitting?.(true);

            // Basic client-side checks
            if (!email || !id || !yubikeyserialnumber) {
                toast.error('Please fill ID and YubiKey Serial Number. (User email is required to send the message.)', {
                    position: "top-right", autoClose: 5000, theme: "light",
                });
                return;
            }

            const { data } = await Axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/create_customer_code`,
                { email, id, yubikeyserialnumber }
            );

            if (data?.success) {
                // success path from server (email sent or at least account created)
                const extra = data.code ? ` (Code: ${data.code})` : '';
                toast.success(`${data.msg}${extra}`, {
                    position: "top-right", autoClose: 5000, theme: "light",
                });
                resetForm();
            } else {
                // known failures (org exists, yubikey exists, or server-reported error)
                toast.error(data?.msg || 'Failed to create customer code.', {
                    position: "top-right", autoClose: 5000, theme: "light",
                });
            }
        } catch (err) {
            console.error('Error creating customer code:', err);
            toast.error('An error occurred while creating the customer code.', {
                position: "top-right", autoClose: 5000, theme: "light",
            });
        } finally {
            setSubmitting?.(false);
        }
    };

    // const handleCreateCustomer = (values, { resetForm }) => {
    //     const email = localStorage.getItem('userEmail');

    //     Axios.post(`${process.env.REACT_APP_BACKEND_URL}/create_customer_code`, {
    //         email: email,
    //         id: values.id,
    //         yubikeyserialnumber: values.yubikeyserialnumber,
    //     }).then((response) => {
    //         if (response.data.success) {
    //             toast.success(`${response.data.msg}`, {
    //                 position: "top-right",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "light",
    //             });
    //             resetForm();
    //         } else {
    //             toast.error(`${response.data.msg}`, {
    //                 position: "top-right",
    //                 autoClose: 5000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "light",
    //             });
    //         }
    //     }).catch((error) => {
    //         console.error('Error creating customer code:', error);
    //         toast.error('An error occurred while creating the customer code.', {
    //             position: "top-right",
    //             autoClose: 5000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
    //             theme: "light",
    //         });
    //     });
    // };

    const handleBack = () => {
        console.log("Back button clicked!");
        console.log("Current path:", location.pathname);

        // Dismiss any active toasts before navigating
        toastHelper.dismiss();

        // Check if we can go back in history
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1);  // Go back one step in history
            console.log("Navigating back one step.");
        } else {
            // If no history, navigate to the dashboard without adding an entry
            navigate('/dashboard', { replace: true });
            console.log("No history to go back, redirecting to dashboard.");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('@user');
        localStorage.removeItem('userEmail');
        toastHelper.dismiss();  // Ensure any active toasts are dismissed before logout
        navigate('/', { replace: true });  // Use replace to avoid adding history
    };

    return (
        <div>
            <div className='logo-VELOX'>
                <img src={Img} alt="VELOX Life Safety Inc." className="logo" />
                <button className='back-botton' onClick={handleBack}>BACK</button>
                <button className='signout-botton' onClick={handleLogout}>SIGN OUT</button>
            </div>
            <hr className='login-breakline' />
            <div className='register-card'>
                <h1 className='register'>Create Customer Registration Code</h1>
                <Formik
                    initialValues={{
                        id: '',
                        yubikeyserialnumber: '',
                    }}
                    onSubmit={handleCreateCustomer}
                >
                    <Form className="register-form">
                        <div className="register-form-group">
                            <Field name="id" type='text' className="register-form-id-field" placeholder="Company ID" />
                        </div>

                        <div className="register-form-group">
                            <Field name="yubikeyserialnumber" type='text' className="register-form-yubikeyserialnumber-field" placeholder="YubiKey Serial Number" />
                        </div>

                        <button className="createuser-button" type="submit">
                            Create Customer
                        </button>
                    </Form>
                </Formik>
            </div>
            <ToastContainer position='top-right' />
        </div>
    );
};

export default RegisterCustomerCode;
